import { render, staticRenderFns } from "./Campus.vue?vue&type=template&id=f3ebd308&scoped=true&"
import script from "./Campus.vue?vue&type=script&lang=js&"
export * from "./Campus.vue?vue&type=script&lang=js&"
import style0 from "./Campus.vue?vue&type=style&index=0&id=f3ebd308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ebd308",
  null
  
)

component.options.__file = "Campus.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardTitle,
  VContainer,
  VFlex,
  VImg,
  VLayout,
  VTextField,
})
